import React from 'react';
import PropTypes from 'prop-types';
import TagManager from 'react-gtm-module';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import classnames from 'classnames';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import LogOutIcon from '@material-ui/icons/ExitToApp';
import { withStyles } from '@material-ui/core/styles';
import PeopleOutline from '@material-ui/icons/PeopleOutline';
// import SettingsOutline from '@material-ui/icons/SettingsOutlined';
import BuildOutlined from '@material-ui/icons/BuildOutlined';
// import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';
// import MenuBookRoundedIcon from '@material-ui/icons/MenuBookRounded';
import NoteOutlinedIcon from '@material-ui/icons/NoteOutlined';
import SettingsIcon from '@material-ui/icons/Settings';
import HelpIcon from '@material-ui/icons/Help';
import AssignmentOutline from '@material-ui/icons/AssignmentOutlined';
import InsertChartOutlinedSharpIcon from '@material-ui/icons/InsertChartOutlinedSharp';
import { logoutAction } from '../../store/actions/login';
import { redirectBuildTools } from '../../store/actions/navigation';
import { constructGTM } from '../../utilities/helpers';

import styles from './styles';
import JHLogoIcon from '../JHLogoIcon';
import Footer from '../Footer';
import { ACCEL_URL } from '../../constants';

const propTypes = {
  classes: PropTypes.shape({
    wrapper: PropTypes.string,
    sidebar: PropTypes.string,
    sidebarWrapper: PropTypes.string,
    main: PropTypes.string,
  }).isRequired,
  handleClose: PropTypes.func,
  handleLogout: PropTypes.func.isRequired,
  // handleBuildToolsRedirect: PropTypes.func.isRequired,
};

export class NavMenu extends React.PureComponent {
  render() {
    const {
      classes,
      handleClose,
      handleLogout,
      // handleBuildToolsRedirect,
      handleRedirectToAccel,
    } = this.props;

    const registerEventToGtm = eventName => {
      // Log event to GTM
      TagManager.initialize(
        constructGTM({
          dataLayer: {
            event: `User clicked on ${eventName}`,
          },
        }),
      );
    };

    return (
      <div className={classes.root}>
        <div className={classes.navLogo}>
          <JHLogoIcon />
        </div>
        <NavLink
          className={classes.navLink}
          activeClassName={classes.activeLink}
          to="/my-build-profile"
          onClick={handleClose}
        >
          <div className={classes.sidebarItem}>
            <Button color="secondary" className={classes.button} fullWidth>
              <PeopleOutline className={classes.leftIcon} />
              <span className={classes.sidebarItemLabel}>
                myHardies Profile
              </span>
            </Button>
          </div>
        </NavLink>
        <NavLink
          className={classes.navLink}
          activeClassName={classes.activeLink}
          to="/my-jobs"
          onClick={handleClose}
        >
          <div className={classes.sidebarItem}>
            <Button color="secondary" className={classes.button} fullWidth>
              <AssignmentOutline className={classes.leftIcon} />
              <span className={classes.sidebarItemLabel}>Jobs</span>
            </Button>
          </div>
        </NavLink>
        {/* <div className={classes.sidebarItem}>
          <Button
            color="secondary"
            className={classes.button}
            fullWidth
            onClick={() => {
              registerEventToGtm();
              handleBuildToolsRedirect(localStorage.getItem('accessToken'));
            }}
          >
            <BuildOutlined className={classes.leftIcon} />
            <span className={classes.sidebarItemLabel}>Tools</span>
          </Button>
        </div> */}
        <div className={classes.sidebarItem}>
          <Button
            color="secondary"
            className={classes.button}
            fullWidth
            // href="https://accel.com.au/technical_literature-brbpr.php?category=9"
            // target="_blank"
            onClick={() => {
              registerEventToGtm('Product Guides');
              handleRedirectToAccel(
                localStorage.getItem('accessToken'),
                ACCEL_URL.ACCEL_PRODUCT_GUIDES,
              );
            }}
          >
            <NoteOutlinedIcon className={classes.leftIcon} />
            <span className={classes.sidebarItemLabel}>Product Guides</span>
          </Button>
        </div>
        <div className={classes.sidebarItem}>
          <Button
            color="secondary"
            className={classes.button}
            fullWidth
            // target="_blank"
            // href="https://accel.com.au/multimedia-resources.php"
            onClick={() => {
              registerEventToGtm('Installation Advice');
              handleRedirectToAccel(
                localStorage.getItem('accessToken'),
                ACCEL_URL.ACCEL_INSTALLATION_ADVICE,
              );
            }}
          >
            <InsertChartOutlinedSharpIcon className={classes.leftIcon} />
            <span className={classes.sidebarItemLabel}>
              Installation Advice
            </span>
          </Button>
        </div>
        <div className={classes.sidebarItem}>
          <Button
            color="secondary"
            className={classes.button}
            fullWidth
            // href="https://accel.com.au/product_calculator_1.php"
            // target="_blank"
            onClick={() => {
              registerEventToGtm('Business Tools');
              handleRedirectToAccel(
                localStorage.getItem('accessToken'),
                ACCEL_URL.ACCEL_BUSINESS_TOOLS,
              );
            }}
          >
            <BuildOutlined className={classes.leftIcon} />
            <span className={classes.sidebarItemLabel}>Business Tools</span>
          </Button>
        </div>
        <NavLink
          className={classes.navLink}
          activeClassName={classes.activeLink}
          to="/settings"
          onClick={handleClose}
        >
          <div className={classes.sidebarItem}>
            <Button color="secondary" className={classes.button} fullWidth>
              <SettingsIcon className={classes.leftIcon} />
              <span className={classes.sidebarItemLabel}>Settings</span>
            </Button>
          </div>
        </NavLink>
        <NavLink
          className={classes.navLink}
          activeClassName={classes.activeLink}
          to="/faq"
          onClick={handleClose}
        >
          <div className={classes.sidebarItem}>
            <Button color="secondary" className={classes.button} fullWidth>
              <HelpIcon className={classes.leftIcon} />
              <span className={classes.sidebarItemLabel}>FAQ</span>
            </Button>
          </div>
        </NavLink>
        {/*
        <div className={classes.sidebarItem}>
          <Button color="secondary" className={classes.button} fullWidth>
            <SettingsOutline className={classes.leftIcon} />
            <span className={classes.sidebarItemLabel}>Settings</span>
          </Button>
        </div>
        */}
        <Divider className={classes.divider} />
        <div className={classnames([classes.sidebarItem, classes.navLink])}>
          <Button
            color="secondary"
            className={classes.button}
            fullWidth
            onClick={() => {
              if (handleClose) handleClose();
              handleLogout(localStorage.getItem('accessToken'));
            }}
          >
            <LogOutIcon className={classes.leftIcon} />
            <span className={classes.sidebarItemLabel}>Log out</span>
          </Button>
        </div>
        <Footer />
      </div>
    );
  }
}

NavMenu.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  handleLogout: accessToken => dispatch(logoutAction(accessToken)),
  handleBuildToolsRedirect: accessToken =>
    dispatch(redirectBuildTools(accessToken)),
  handleRedirectToAccel: (accessToken, accelType) =>
    dispatch(redirectBuildTools(accessToken, accelType)),
});

export default withStyles(styles)(
  connect(
    null,
    mapDispatchToProps,
  )(NavMenu),
);
